import type { UserChatMessage } from '@/lib/types'

interface Props {
  msg: UserChatMessage
}

/**
 * Right-aligned bubble for the rep's typed note.
 * Rendered as monospace to preserve any markdown structure they typed.
 */
export function UserBubble({ msg }: Props) {
  return (
    <div className="flex justify-end">
      <div className="max-w-[85%] rounded-lg rounded-tr-sm bg-blue-600 px-3 py-2 text-[13px] text-white shadow-sm">
        <pre className="whitespace-pre-wrap font-mono leading-relaxed">{msg.content}</pre>
      </div>
    </div>
  )
}
